module.exports = __webpack_public_path__ + "static/media/slider01.aa2ba6bd.jpg";